var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/file/upload_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UploadIcon; Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M9.83002 7.99999H11V9.99999V14H13V9.99999V7.99999H14.17L12 5.82999L9.83002 7.99999Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "UploadIcon; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10L12 3L19 10H15V16H9V10H5ZM13 10V8H14.17L12 5.83L9.83 8H11V10V14H13V10Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "UploadIcon; Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    d: "M5 18H19V20H5V18Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.4d7fa0ea40d347628b7a363161ec5aeb.svg";
export { ForwardRef as ReactComponent };